import { ThemeProvider } from "@mui/material";
import React, {useEffect} from "react";
import { useNavigate } from "react-router-dom";
import MainGuide from "../../components/guide/MainGuide";
import Header from "../../layouts/Header";
import theme from "../../layouts/theme-onboarding/Theme";
import Storage from "../../services/Storage";

export default function Guide() {
  const navigate = useNavigate();

  useEffect(() => {
    if (Storage.getLocalAccessToken() !== null) {
      navigate('/dashboard', { replace: true })
    }
  }, [navigate]);

  return (
    <div>
      <Header></Header>
      <ThemeProvider theme={theme}>
        <MainGuide />
      </ThemeProvider>
    </div>
  )
}